import { Router } from 'express';
import * as controller from './settings.controller';
import { authMiddleware } from '../../middleware/auth.middleware';
import { requireRole } from '../../middleware/rbac.middleware';

const router = Router();
router.use(authMiddleware);
router.use(requireRole('admin', 'super_admin'));

router.post('/companies', controller.createCompany);
router.get('/companies', controller.listCompanies);
router.delete('/companies/:id', controller.deleteCompany);

router.post('/departments', controller.createDepartment);
router.get('/departments', controller.listDepartments);
router.delete('/departments/:id', controller.deleteDepartment);

export default router;
